import {css} from '@mui/material';
import {DlMuiChip, DlMuiDeleteIcon, DlMuiDynamicIcon, HierarchyNode} from '@wallaby-ui/core';
import React, {useCallback} from 'react';

import {MedicationAtc} from './PhRecommendationDrpFormatters';
import {NormalizedOption} from '../light';
import {TooltipWrapper} from '../TooltipWrapper';

export function useInactiveAtcRenderProps(t: (key: string) => string) {
  const renderOption = useCallback(
    (props, option, rowInfo) => {
      const atc = (option as NormalizedOption<MedicationAtc>).original?.original;
      return (
        <div {...props} key={`${rowInfo?.index}`} style={{display: 'flex', alignItems: 'center', gap: 4}}>
          {atc?.isActive === false ? (
            <TooltipWrapper
              tooltip={t('hospitalization.detail.phRec.drp.medicationAtcId.inactive')}
              wrapperStyle={{display: 'inline-flex', lineHeight: '1'}}
            >
              <span style={{display: 'inline-flex', alignItems: 'center'}}>{atc.label}</span>
              <DlMuiDynamicIcon
                iconName='badgeExclamationIcon'
                noButtonStyles
                sx={{'&&': {paddingLeft: '3px !important', paddingRight: '0 !important'}}}
                svgIconStyle={{width: '100%', height: '100%', color: 'var(--dlThemeWarning)'}}
              />
            </TooltipWrapper>
          ) : (
            <span>{atc.label}</span>
          )}
        </div>
      );
    },
    [t]
  );

  const renderTag = useCallback(
    (info, index, tagProps) => {
      const atc = info.original as MedicationAtc;
      return (
        <DlMuiChip
          {...tagProps}
          key={`${info.optionId}-${index}`}
          label={
            <span style={{display: 'inline-flex', alignItems: 'center', gap: 4}}>
              {atc?.isActive === false ? (
                <TooltipWrapper
                  tooltip={t('hospitalization.detail.phRec.drp.medicationAtcId.inactive')}
                  wrapperStyle={{display: 'inline-flex', lineHeight: '1'}}
                >
                  <span style={{display: 'inline-flex', alignItems: 'center'}}>{info.label}</span>
                  <DlMuiDynamicIcon
                    iconName='badgeExclamationIcon'
                    noButtonStyles
                    sx={{'&&': {paddingLeft: '3px !important', paddingRight: '0 !important'}}}
                    svgIconStyle={{width: '100%', height: '100%', color: 'var(--dlThemeWarning)'}}
                  />
                </TooltipWrapper>
              ) : (
                <span style={{display: 'flex', alignItems: 'center'}}>{info.label}</span>
              )}
            </span>
          }
          deleteIcon={<DlMuiDeleteIcon />}
        />
      );
    },
    [t]
  );

  const getNodeIcon = useCallback(
    (node: HierarchyNode<NormalizedOption<MedicationAtc>>) => {
      const atc = node.original;
      return atc?.isActive === false ? (
        <TooltipWrapper tooltip={t('hospitalization.detail.phRec.drp.medicationAtcId.inactive')}>
          <DlMuiDynamicIcon
            iconName='badgeExclamationIcon'
            noButtonStyles
            style={{padding: 0, display: 'flex', alignItems: 'center'}}
            svgIconStyle={{width: '100%', height: '100%', color: 'var(--dlThemeWarning)'}}
          />
        </TooltipWrapper>
      ) : null;
    },
    [t]
  );

  return {renderOption, renderTag, getNodeIcon};
}
